// Selection model for the patient welcome board's queue navigation.
//
// The board shows either a specific patient or a general welcome/thankyou
// screen. We model the general screen as `selectedId === null`, sitting at
// position 0 of a conceptual list: [general, patient0, patient1, ...].
//
// `ids` is the ordered list of queue appointment ids (the order the doctor
// sees in the คิวรอตรวจ table). These helpers are pure — no Vue/DOM — so the
// navigation rules can be unit-tested in isolation.

// ArrowDown: general -> first patient; patient -> next patient, clamped at the
// last. An unknown id (e.g. the queue changed underneath us) jumps to the
// first patient so the doctor isn't stranded.
export function nextSelection(ids, sel) {
  if (sel === null) return ids.length ? ids[0] : null;
  const i = ids.indexOf(sel);
  if (i === -1) return ids.length ? ids[0] : null;
  return i < ids.length - 1 ? ids[i + 1] : sel;
}

// ArrowUp: first patient (or unknown id) -> general; later patient -> previous
// patient; already on general -> stays on general (clamp at the top).
export function prevSelection(ids, sel) {
  if (sel === null) return null;
  const i = ids.indexOf(sel);
  if (i <= 0) return null;
  return ids[i - 1];
}

// After a live queue update: if the selected patient is no longer in the
// queue, fall back to the general screen. General (null) always stays valid.
export function reconcileSelection(ids, sel) {
  if (sel === null) return null;
  return ids.indexOf(sel) === -1 ? null : sel;
}

// ArrowRight/ArrowLeft cycle through the post-op treatment screens, wrapping at
// both ends (Right past the last -> first; Left past the first -> last). `keys`
// is the ordered list of treatment keys; `key` is the current one. An unknown
// key falls back to the first treatment; an empty list returns `key` unchanged.
export function nextPostOp(keys, key) {
  if (!keys.length) return key;
  const i = keys.indexOf(key);
  if (i === -1) return keys[0];
  return keys[(i + 1) % keys.length];
}

export function prevPostOp(keys, key) {
  if (!keys.length) return key;
  const i = keys.indexOf(key);
  if (i === -1) return keys[0];
  return keys[(i - 1 + keys.length) % keys.length];
}
